import {
    logImportSourceActions,
    logImportSourceThunks as defaultThunks,
    logImportSourceSelectors as defaultSelectors,
    logImportSourceReducer,
} from './LogImportSource-slice';
import * as thunks from './LogImportSource-thunks';
import * as selectors from './LogImportSource-selectors';

const logImportSourceThunks = { ...defaultThunks, ...thunks };
const logImportSourceSelectors = { ...defaultSelectors, ...selectors };

export {
    logImportSourceSelectors,
    logImportSourceActions,
    logImportSourceThunks,
    logImportSourceReducer,
};
